import { Link } from 'react-router-dom';

export default function AboutPage() {
  return (
    <div data-testid="about-page">
      <section className="max-w-7xl mx-auto px-6 md:px-12 py-20 md:py-32 grid grid-cols-1 md:grid-cols-12 gap-10 items-end">
        <div className="md:col-span-7">
          <p className="overline mb-3">Our story</p>
          <h1 className="font-serif-display text-5xl md:text-7xl leading-[1.02]">A quiet kind<br/>of luminous.</h1>
        </div>
        <div className="md:col-span-5">
          <p className="text-lum-text2 text-base leading-relaxed">
            Lumière Skin began with a single question — what if skincare felt less like work and more like a ritual? Three editorial masks. Clinically proven actives. Designed for every skin, from 14 to 80.
          </p>
        </div>
      </section>

      <section className="bg-lum-bg2">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 md:py-32 grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <h2 className="font-serif-display text-4xl md:text-5xl leading-[1.05]">Three masks.<br/>One philosophy.</h2>
          </div>
          <div className="md:col-span-7 grid grid-cols-1 md:grid-cols-3 gap-8">
            {[
              { t: 'Clinically active', d: 'Each mask is formulated with concentrated, dermatologist-tested actives at meaningful percentages.' },
              { t: 'Editorial care', d: 'A 15-minute ritual that pairs with your favourite playlist, candle, and quiet.' },
              { t: 'For every skin', d: 'Fragrance-light, vegan, cruelty-free. Loved by women 14 to 80, recommended for all skin types.' },
            ].map((c) => (
              <div key={c.t}>
                <p className="font-serif-display text-2xl mb-3">{c.t}</p>
                <p className="text-sm text-lum-text2 leading-relaxed">{c.d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="max-w-5xl mx-auto px-6 py-24 md:py-32 text-center">
        <h2 className="font-serif-display text-4xl md:text-6xl leading-[1.05]">Glow that feels like you.</h2>
        <p className="mt-6 text-lum-text2 max-w-xl mx-auto">Choose a mask. Light a candle. Press play. The next 20 minutes are yours.</p>
        <Link to="/shop" data-testid="about-shop-cta" className="btn-primary mt-10 inline-flex">Begin your ritual</Link>
      </section>
    </div>
  );
}
